/** The `connect` area: the page a person sees when an app like Claude asks to
 *  work with their Tesserano (docs/AGENT_ACCESS.md §6a step 4). Owned by the
 *  stage 2 slot people (docs/I18N.md §11). `{app}` is the app's own name, as
 *  it registered ("Claude"). Never says OAuth, MCP, token, key, scope or
 *  grant (§6a, "Words"). */
export const connect = {
  'connect.title': '{app} wants to work with your Tesserano',
  /** The default and every choice, in one sentence each. */
  'connect.summary.write':
    '{app} can see and change the items you can, and cannot share them or change who sees them.',
  'connect.summary.read': '{app} can see the items you can, and cannot change them.',
  /** `items`: the titles of the chosen items, joined. */
  'connect.summary.writeUnder':
    '{app} can see and change the items you can under {items}, and cannot share them or change who sees them.',
  'connect.summary.readUnder':
    '{app} can see the items you can under {items}, and cannot change them.',
  'connect.summary.manage':
    '{app} can see, change and share the items you can, and change who sees them.',
  'connect.summary.manageUnder':
    '{app} can see, change and share the items you can under {items}, and change who sees them.',
  /** The second sentence when the person chose where: `groups` is the
   *  chosen groups' names, in their own words. */
  'connect.summary.where.groups': 'Only in {groups}.',
  'connect.summary.where.groupsOwn': 'Only in {groups}, and in your own items.',
  'connect.summary.where.own': 'Only in your own items.',
  'connect.existing':
    'You connected {app} before. Allow keeps that connection, with any change you make here.',
  /** `host`: where the browser goes next, e.g. claude.ai. */
  /** Allow moves the person's connection from an earlier registration of the
   *  app to this one; said plainly, before they press it. */
  'connect.replaces':
    'You already have {app} connected. Allow replaces that connection with this one, and the old one stops working.',
  'connect.returnsTo': 'Afterwards you go back to {host}.',
  'connect.allow': 'Allow',
  'connect.change': 'Change',
  'connect.cancel': 'Cancel',
  'connect.may.label': 'What {app} may do',
  'connect.pick.title': 'Where {app} may work',
  'connect.pick.subtitle': '{app} reaches this item and everything below it.',
  'connect.pick.search': 'Search for an item',
  'connect.unavailable.title': 'This link no longer works',
  'connect.unavailable.body': 'Go back to the app you came from and connect again.',
  'connect.error.expired': 'This request has expired. Go back to the app and connect again.',
  'connect.error.onlyPerson': 'Only a person can allow an app.',
} as const;
